export enum Orders {
  GET_ORDERS = "ORDERS_GET_DATA",
  SET_DATA = "ORDERS_SET_DATA",
  SET_META = "ORDERS_SET_META",
  SET_PRODUCTS = "ORDERS_SET_ORDER_PRODUCTS",
}

export enum ProductKeys {
  quantity = "quantity",
  stock = "stock",
  id = "id",
  image = "image",
  name = "name",
  price = "price",
  promoPrice = "promo_price",
  promoStock = "promo_stock",
  purchasePrice = "purchase_price",
  purchasePromoPrice = "purchase_promo_price",
  customTotalPrice = "custom_total_price",
  shipped = "shipped",
  expected = "expected",
  reservedUntil = "reserved_until",
  reservedDays = "reserved_days",
  total = "total",
  sku = "sku",
  margin = "margin",
  benefit = "benefit",
}

export enum ExtraKeys {
  product = "product",
}

export type HeaderKeys = ProductKeys | ExtraKeys;
